import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
// import AuthNavbar from "components/Navbars/AuthNavbar.jsx";
import Footer from 'components/Footer/Footer.jsx';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';

import routes from 'Routes.js';

import pagesStyle from 'assets/jss/material-dashboard-pro-react/layouts/authStyle.jsx';

import register from 'assets/img/register.jpeg';
import login from 'assets/img/login.jpeg';
import lock from 'assets/img/lock.jpeg';
import error from 'assets/img/clint-mckoy.jpg';
import pricing from 'assets/img/bg-pricing.jpeg';

class Pages extends React.Component {
  wrapper = React.createRef();

  componentDidMount() {
    document.body.style.overflow = 'unset';
  }

  getRoutes = routes => {
    return routes.map((prop, key) => {
      const { collapse, views, layout, component: Component } = prop;
      if (collapse) {
        return this.getRoutes(views);
      }
      if (layout === '/auth') {
        return (
          <Route
            exact
            path={`${layout}${prop.path}`}
            // component={Component}
            render={({ staticContext, ...routeProps }) => (
              <ErrorBoundary>
                <Component {...routeProps} />
              </ErrorBoundary>
            )}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  getBgImage = () => {
    if (window.location.pathname.indexOf('/auth/register-page') !== -1) {
      return register;
    } else if (window.location.pathname.indexOf('/auth/login-page') !== -1) {
      return login;
    } else if (window.location.pathname.indexOf('/auth/pricing-page') !== -1) {
      return pricing;
    } else if (
      window.location.pathname.indexOf('/auth/lock-screen-page') !== -1
    ) {
      return lock;
    } else if (window.location.pathname.indexOf('/auth/error-page') !== -1) {
      return error;
    }
  };

  getActiveRoute = routes => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  render() {
    // const { classes, ...rest } = this.props;
    const { classes } = this.props;
    return (
      <div>
        {/* <AuthNavbar brandText={this.getActiveRoute(routes)} {...rest} /> */}
        <div className={classes.wrapper} ref={this.wrapper}>
          <div
            className={classes.fullPage}
            style={{ backgroundImage: 'url(' + this.getBgImage() + ')' }}>
            <Switch>
              {this.getRoutes(routes)}
              <Redirect from="/auth" to="/auth/login-page" />
            </Switch>
            <Footer white />
          </div>
        </div>
      </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(pagesStyle)(Pages);
